import { createFeature, createReducer, on } from '@ngrx/store';
import { Appointment } from 'fhir/r4';
import { SetBookedAppointments } from '../actions/appointment-actions';

export const APPOINTMENTS_STATE_KEY = 'appointments';

export type AppointmentsState = {
  bookedAppointments: Appointment[];
};

const initialState = {
  bookedAppointments: [],
};

const reducer = createReducer(
  initialState,
  on(
    SetBookedAppointments,
    (state: AppointmentsState, { bookedAppointments }): AppointmentsState => {
      return {
        ...state,
        bookedAppointments,
      };
    },
  ),
);

export const bookedAppointmentsFeature = createFeature({
  name: APPOINTMENTS_STATE_KEY,
  reducer,
});
